export default import.meta.ROLLDOWN_FILE_URL_iRN8hgNCsF5UnncHSkX4dw